import { createFileRoute } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { MarketingReportPage } from '@/features/reports/marketing/marketing-report-page'
import { formatDocumentTitle } from '@/lib/document-title'

/** Reports › Marketing at `/$orgId/reports/marketing`: the reports grant together with a Campaigns grant. */
export const Route = createFileRoute('/_auth/$orgId/reports/marketing')({
  component: MarketingRoute,
})

function MarketingRoute() {
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Marketing')}</title>
      </Helmet>
      <MarketingReportPage />
    </>
  )
}
